import { BusyButtonLink } from '@ztechapps/webui.button'
import { Icon } from '@ztechapps/webui.util'
import React from 'react'
import { useConfirmDialog, useError, useMutation } from '@ztechapps/common.hook'
import type { DeleteActivityProps } from './constants'
import { useActivityContext } from './Context'
import type { Activity } from '@ztechapps/common.contract'
import { mutationUpdateRemarksActivity } from './graphql'

export const DeleteActivity = ({ _id }: DeleteActivityProps) => {
  const { entityName, documentId } = useActivityContext()
  const updateMutation = useMutation<Activity>({ query: mutationUpdateRemarksActivity(entityName) })

  const [onDelete, , { loading, error }] = updateMutation ?? []

  const { onError } = useError(error)

  const { onConfirm } = useConfirmDialog({
    title: 'Delete Activity?',
    text: 'Are you sure you want to delete this activity entry?',
    buttons: {
      confirm: {
        text: 'Yes, delete it!',
      },
    },
    confirmed: async () => {
      try {
        await onDelete({
          filter: { _id: documentId, 'remarksActivity._id': _id },
          input: { isDeleted: true },
        })
      } catch (e) {
        onError(e)
      }
    },
  })

  return (
    <BusyButtonLink
      disabled={loading}
      icon={<Icon name="trash" className="text-danger" />}
      bsStyle="danger"
      title="Delete activity."
      onClick={onConfirm}
      text="Delete"
    />
  )
}
